import { Injectable, Injector, computed, inject, signal } from '@angular/core';
import { AnalyticsTrackingService } from './analytics-tracking.service';

export const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';

export type CookieConsentChoice = 'accepted' | 'rejected';

@Injectable({
	providedIn: 'root',
})
export class CookieConsentService {
	private readonly injector = inject(Injector);
	private readonly choice = signal<CookieConsentChoice | null>(
		this.readStoredChoice()
	);

	readonly hasChoice = computed(() => this.choice() !== null);
	readonly shouldShowBanner = computed(() => this.choice() === null);
	readonly isAccepted = computed(() => this.choice() === 'accepted');
	readonly isDenied = computed(() => this.choice() !== 'accepted');

	accept(): void {
		this.persist('accepted');
	}

	reject(): void {
		this.persist('rejected');
	}

	private persist(choice: CookieConsentChoice): void {
		localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, choice);
		this.choice.set(choice);
		this.injector.get(AnalyticsTrackingService).syncFromConsent();
	}

	private readStoredChoice(): CookieConsentChoice | null {
		const stored = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
		if (stored === 'accepted' || stored === 'rejected') {
			return stored;
		}
		return null;
	}
}
